import React from 'react'

import Grid from '../../../../components/Grid'
import ContactAreaItem from './ContactAreaItem'
import { items as _items } from './data'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const ContactArea: React.FC<{ locale: ELocale; items?: TItem[] }> = (props) => {
  const { locale, items = _items } = props
  let filtredItems
  if (locale == ELocale.DE_CH) {
    filtredItems = items.filter((it) => !it.label.endsWith('Bestellung'))
  } else {
    filtredItems = items
  }
  return (
    <div className="text-white overflow-auto bg-nightblue">
      <Grid.Container>
        <p className="text-24 leading-32 mx-48 my-32 text-center">Kontaktieren Sie uns, wir helfen gerne.</p>
        <Grid.Row as="ul" className="mt-32 justify-around">
          {filtredItems.map((item) => (
            <ContactAreaItem key={item.label} item={item} locale={locale} />
          ))}
        </Grid.Row>
      </Grid.Container>
    </div>
  )
}

export { ContactArea as default }
